<template>
  <a-row id="user-company-row" :gutter='16'>
    <!-- <a-col class="gutter-row" :sm="24" :md="24" :lg="12" :xl="6" >
        <div class="gutter-box" style="background-color: #64b0f2;padding-bottom:35px;"> -->
            <!-- <div class="title">欢迎您：</div>

            <div class="content">
                <div class="num" style="font-size:20px;padding-top:15px;">{{topData.deptName}}</div>
            </div> -->
            <!-- <div class="mark">使用剩余天数{{topData.expireDate}} </div>
            <a-button size='small' style="float:right; margin:5px 0 0 8px" @click="openPayMent(topData.expireDate)">  -->
              <!-- <router-link :to="{ 
                  path: '/user/company/pay',
                  name:'pay', 
                  query:{expireDate:topData.expireDate}}"
                >支付年费</router-link> -->
                <!-- 支付年费
            </a-button> -->
        <!-- </div>
    </a-col> -->
    <a-col class="gutter-row" :sm="12" :md="12" :lg="6" :xl="6">
        <div class="gutter-box" style="background-color:#3db9dc">
            <div class="title">证书数<i v-if="topData.datarangeName">（{{topData.datarangeName}}）</i></div>
            <div class="content" @click="goagency(2)">
                <span class="num">{{topData.certNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">今日新增{{topData.newsCertNum}}份证书</div>
        </div>
    </a-col>
    <a-col class="gutter-row" :sm="12" :md="12" :lg="6" :xl="6">
        <div class="gutter-box" style="background-color: #5cd580">
            <div class="title">关键件<i v-if="topData.datarangeName">（{{topData.datarangeName}}）</i></div>
            <div class="content" @click="goagency(4)">
                <span class="num">{{topData.keyCertNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">今日新增{{topData.newKeyCertNum}}份</div>
        </div>
    </a-col>
    <a-col class="gutter-row" :sm="12" :md="12" :lg="6" :xl="6">
        <div class="gutter-box" style="background-color: #f1b53d ">
            <div class="title">无证报告<i v-if="topData.datarangeName">（{{topData.datarangeName}}）</i></div>
            <div class="content" @click="goagency(3)">
                <span class="num">{{topData.reportNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">今日新增{{topData.newsReportNum}}份报告</div>
        </div>
    </a-col>
    <a-col class="gutter-row" :sm="12" :md="12" :lg="6" :xl="6">
        <div class="gutter-box" style="background-color: #ff5d48">
            <div class="title">即将到期证书<i v-if="topData.datarangeName">（{{topData.datarangeName}}）</i></div>
            <div class="content">
                <span class="num">{{topData.soonExpireNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">已过期证书{{topData.expireNum}}份</div>
        </div>
    </a-col>
  </a-row>
</template>
<script>
export default {
  props:{
    topData:Object
  },
  data() {
    return {
      basicData:[]
    };
  },
  
  methods: {
    goagency(type){
      let userMsg = this.$store.state.user.user;
      let roles = userMsg.roles;
      if(type==2 && roles.includes('CERTIFICATE_SELECT')){
        this.$router.push('/product/manage')
      } else if(type==3 && roles.includes('REPORT_SELECT')){
        this.$router.push('/product/report')
      } else if (type == 4 && roles.includes('KEYPIECECERTIFICATE_SELECT')) {
        this.$router.push('/product/keyPartCertificate')
      }
    },
    /**
     * 打开支付弹出框
     */
    openPayMent(expireDate){
      this.$emit('openPayMent',expireDate)
    }
  },
  watch: {
    topData(value){
      this.basicData = value
    } 
  },
};
</script>

<style lang="less" scoped>
#user-company-row {
  overflow: hidden;
  .gutter-box {
    padding: 5px 10px;
    border: 1px solid #eee;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,.1);
    border-radius: 8px;
    overflow: hidden;
    .title{
        font-size: 14px;
        color: #fff
    }
    .content{
        min-height: 80px;
        color: #fff;
        text-align: center;
        vertical-align: center;
        border-bottom: 1px;
        border-bottom: 1px solid #fff;
        .num{
            font-size: 50px;
            word-wrap: break-word;
        }
        .cite{
            font-size: 14px;
            margin-left: 20px;
        }
    }
    .mark{
        float: left;
        line-height: 30px;
        color: #fff;
    }
  }
  /deep/.ant-card {
    border-radius: 0px;
    height: 200px;
    border: 0;
    .ant-col-4{
        border: 1px solid #eee;
    }
    .ant-card-body {
      height: 100%;
    }

    .info {
      line-height: 200px;
      display: flex;
      align-items: center;

      .avatar {
      }

      .username {
        font-weight: bold;
        font-size: 18px;
        color: #333;
        margin-left: 12px;
      }
    }

    .list {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .item {
        height: 63%;
        padding: 3% 0;
        width: ~'calc(33.3% - 3px)';
        text-align: center;
        border-right: 2px solid #ccc;
        .item-t {
          font-size: 16px;
          padding-bottom: 6px;
        }

        .item-b {
          font-size: 18px;
          font-weight: bold;
        }
      }
      .item:last-child{
        border-right: 0;
      }
    }


  }
}
</style>
